import Vue from "vue";
import VueRouter from "vue-router";
import routes from 'vue-auto-routing'

Vue.use(VueRouter);
console.log(routes)

/* Our Vue Router Object */
const router = new VueRouter({
    routes,
    /* Use Pretty URL */
    mode: "history",
    base: "/",
    /* Save The Scroll Position , Useful When Redirecting Back */
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    }
});

/* Middlewares */
router.beforeEach((to, from, next) => {
    /* for all authenticated routes */
    if (to.matched.some(m => m.meta.requiresAuth)) {
        return axios.post(route("api.auth.check")).then(() => {
            const currentWorkstation = router.app.$store.getters['workstation/getWorkstation']
            if(currentWorkstation == null) {
                axios.get(route("api.@workstations")).then(({data}) => {
                    router.app.$store.commit('workstation/setAvailableWorkstations', data)
                }).catch(() => {
                    router.push({name: '404'})
                });
            }

            return next();
        }).catch(e => {
            router.app.$store.commit('auth/logout');
            window.location.assign("/auth/oidc/start");
            return next(false);
        });
    }
    /* If No Middleware, Then Just Proceed As Normal */
    return next();
});

export default router;
